/*
 * GLOBAL CONSTANTS
*/

var PAGE_NAV_SHADOW_HEIGHT = 24;
var MAX_HOTEL_RESULTS = 99999;

var PRICE_RANGE_MIN = 100;
var PRICE_RANGE_MAX = 10000;

var DateTimeMinValue = "0001-01-01T00:00:00";

var GlobalEvents = {
    SearchViewModel: {
        Initialized: 'initialized.searchViewModel'
    }
};

export {
    PAGE_NAV_SHADOW_HEIGHT,
    MAX_HOTEL_RESULTS,
    PRICE_RANGE_MIN,
    PRICE_RANGE_MAX,
    DateTimeMinValue,
    GlobalEvents
}
